module.exports = __webpack_public_path__ + "static/pop-up-43c0afe5c04318e3fcb2f61ce0273ed0.png";